export default __webpack_public_path__ + "static/media/vertical_top_to_bottom_left.fbe7d6a1.PNG";